import Vue from 'vue'
import VueRouter from 'vue-router'
import share from '../views/share.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'share',
    component: share,

  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
